export default __webpack_public_path__ + "static/aftia-story-e00317579d1b622f217b3f814dad13cc.pdf";